/**
 * @description
 * Central location for constants used throughout
 * the application.
 */
export const CONSTANTS = {
  ExternalUrl: {
    MarketingSite: 'https://dunbar148.com',
    TermsAndConditions: 'https://dunbar148.com/terms-of-use',
  },
};

export enum Environment {
  PROD = 'prod',
  STAGING = 'staging',
  LOCAL = 'local',
}
export const VIDEO_ENGAGEMENT_CONSTANTS = {
  watchStartThreshold: 2,
  watchEndOffsetFromEnd: 2,
} as const;
